const isSafeParamKey = (key) =>
  key !== '__proto__' && key !== 'constructor' && key !== 'prototype';

const generateQueryString = params => {
  let result = '';
  let prefix = '?';
  
  for (let key in params) {
    if (!isSafeParamKey(key)) continue;
    result += `${prefix}${key}=${encodeURIComponent(params[key])}`;
    prefix = '&';
  }

  return result;
};

const getQueryParams = (url = window?.location?.href) => {
  const location = new URL(url);
  return Object.fromEntries(
    Array.from(location.searchParams.entries()).filter(([key]) => isSafeParamKey(key))
  );
};

const mergeQueryParams = (newParams, url = window?.location?.href) => {
  const loc = new URL(url);
  const mergedParams = { ...getQueryParams(url), ...newParams };
  const queryString = generateQueryString(mergedParams);

  return new URL(`${loc.origin}${loc.pathname}${queryString}${loc.hash}`);
};

export { generateQueryString, getQueryParams, mergeQueryParams };
